<style>
.prompt-textarea .form-control {
  font-size: 17px;
}

</style>
<template>
    <div class="animated fadeIn">
        <CRow>
            <CCol :lg="7">
                <CCard>
                    <CCardHeader><font-awesome-icon icon="link" /> New Document Template Prompt
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol lg="6" md="6" xl="6">
                                <CInput :lazy="false" label="Name" type="text" placeholder="(e.g gpt-4o-mini)"
                                    autocomplete="off" v-model="ai_model.name"
                                    invalidFeedback="Must be three(3) characters."
                                    :value.sync="$v.ai_model.name.$model"
                                    :isValid="checkIfValid($v.ai_model, 'name')" />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol lg="6" md="6" xl="6">
                                <CSelect label="Provider" :options="providerOptions"
                                    placeholder="Select provider"
                                    :value.sync="$v.ai_model.provider.$model"
                                    :isValid="checkIfValid($v.ai_model, 'provider')" 
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol col="12" class="text-right">
                                <CButton :disabled="!isValid" shape="pill" color="primary" @click="addAiModel()">
                                    <font-awesome-icon icon="save" /> Save
                                </CButton>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators"
export default {
    name: 'DocumentTemplatePromptCreate',
    data() {
        return {
            ai_model: {
                name: '',
                provider: '',
            },
            providerOptions: ['OpenAI', 'Google'],
        }
    },
    created() {
        this.$v.$touch()
        this.$emit('activeTab', 1);
    },
    computed: {
        isValid() { return !this.$v.ai_model.$invalid },
        isDirty() { return this.$v.ai_model.$anyDirty },
    },
    validations: {
        ai_model: {
            name: { required, minLength: minLength(3) },
            provider: { required },
        },
    },
    methods: {
        addAiModel: function () {
            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: "You are trying to create new AI Model.",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => {
                    this.$Progress.start()
                        return axios.post('/drs/ai-model/store', this.ai_model, { validateStatus: () => true }).then(response => {
                        if (response.status == 200) {
                            this.$swal({
                                icon: "success",
                                title: "Success!",
                                text: `${this.ai_model.name} has been added.`,
                            })
                            this.resetAiModel();
                            this.$v.ai_model.$reset()
                            this.$v.ai_model.$touch()
                            this.$Progress.finish()
                        }
                    })
                }
            }).then((result) => {
                if (!result.value) {
                    this.$swal('Cancelled!', '', 'error');
                }
            })
            return;
        },

        resetAiModel: function () {
            this.ai_model = {
                name: '',
                provider: '',
            }
        },
    },
}
</script>
